/*
  Hampton Jitney tour booking (see snippets/hj-tour-passenger-fields.liquid).

  The customer chooses a number of passengers, enters one contact mobile number, and gets a name
  block per passenger. On Add to cart this script, not Dawn's product form, adds the booking: it
  checks every field, then posts one cart line per passenger in a single /cart/add request, each
  line carrying that passenger's name and (multi-day) rooming, plus the shared pickup point,
  contact phone and comments. Then it refreshes Dawn's cart drawer or notification the same way
  Dawn does.

  The submit listener runs in the capture phase on document, before Dawn's own submit handler,
  and stops the event so Dawn doesn't add the item a second time.

  Read form ids with getAttribute: Dawn's product form contains <input name="id">, and a named
  control shadows form.id, so form.id returns that input instead of the form's id.
*/
(function () {
  if (window.hjTourBooking) return;
  window.hjTourBooking = true;

  function formId(form) {
    return form instanceof HTMLFormElement ? form.getAttribute('id') : null;
  }

  function containerFor(form) {
    var id = formId(form);
    if (!id) return null;
    return document.querySelector('[data-hj-passenger-form="' + CSS.escape(id) + '"]');
  }

  function formFor(container) {
    return document.getElementById(container.dataset.hjPassengerForm);
  }

  function fill(template, values) {
    return String(template || '').replace(/\[(\w+)\]/g, function (match, key) {
      return values[key] !== undefined ? values[key] : match;
    });
  }

  function people(container) {
    return container.querySelectorAll('[data-hj-person]');
  }

  function fieldIn(scope, name) {
    return scope.querySelector('[data-hj-passenger-field="' + name + '"]');
  }

  // ---- seats left per variant (from the page), used to cap the passenger count

  function seatsLeft(container) {
    if (!container.hjSeats) {
      try {
        var el = container.querySelector('[data-hj-seats]');
        container.hjSeats = el ? JSON.parse(el.textContent) : {};
      } catch (e) {
        container.hjSeats = {};
      }
    }
    var form = formFor(container);
    var idInput = form && form.querySelector('[name="id"]');
    var seats = idInput && container.hjSeats[idInput.value];
    return typeof seats === 'number' ? seats : Infinity;
  }

  function capCount(container) {
    var count = container.querySelector('[data-hj-count]');
    if (!count) return;
    var left = seatsLeft(container);
    for (var i = 0; i < count.options.length; i++) {
      count.options[i].disabled = Number(count.options[i].value) > Math.max(left, 1);
    }
    if (Number(count.value) > Math.max(left, 1)) {
      count.value = String(Math.max(Math.min(left, count.options.length), 1));
      syncPeople(container);
    }
  }

  // ---- one block of fields per passenger

  function syncPeople(container) {
    var count = container.querySelector('[data-hj-count]');
    var wanted = count ? Number(count.value) || 1 : 1;
    var list = container.querySelector('[data-hj-people]');
    var blocks = people(container);
    var first = blocks[0];

    for (var n = blocks.length; n < wanted; n++) {
      var copy = first.cloneNode(true);
      var number = n + 1;
      copy.querySelectorAll('[id]').forEach(function (el) {
        el.id = el.id + '-' + number;
      });
      copy.querySelectorAll('label[for]').forEach(function (label) {
        label.setAttribute('for', label.getAttribute('for') + '-' + number);
      });
      // Only passenger 1 belongs to the form; the others are read by this script.
      copy.querySelectorAll('[data-hj-passenger-field]').forEach(function (field) {
        field.removeAttribute('name');
        field.removeAttribute('form');
        field.value = '';
        field.setCustomValidity('');
      });
      copy.querySelector('[data-hj-person-title]').textContent = 'Passenger ' + number;
      list.appendChild(copy);
    }
    blocks = people(container);
    for (var k = blocks.length - 1; k >= wanted; k--) blocks[k].remove();
    people(container).forEach(function (block) {
      block.querySelector('[data-hj-person-title]').hidden = wanted < 2;
    });
  }

  // ---- validation

  function validate(field, container) {
    var isSelect = field.tagName === 'SELECT';
    var isTextarea = field.tagName === 'TEXTAREA';
    // Keep line breaks in comments; single-line fields collapse runs of whitespace.
    var value = isSelect ? field.value : isTextarea ? field.value.trim() : field.value.replace(/\s+/g, ' ').trim();
    var message = '';

    if (!isSelect) field.value = value;
    if (field.dataset.hjPassengerField === 'pickup') {
      if (!value) message = container.dataset.msgPickup;
    } else if (field.dataset.hjPassengerField === 'name') {
      if (value.length < 2) message = container.dataset.msgName;
    } else if (field.dataset.hjPassengerField === 'phone') {
      var digits = value.replace(/\D/g, '').length;
      if (digits < 10 || digits > 15) message = container.dataset.msgPhone;
    }

    field.setCustomValidity(message || '');
    return !message;
  }

  function showStatus(container, text) {
    var status = container.querySelector('.hj-passenger__status');
    if (!status) return;
    status.textContent = text || '';
    status.hidden = !text;
  }

  // ---- add to cart

  function buildItems(container, variantId) {
    var shared = {};
    var pickup = fieldIn(container, 'pickup');
    var comments = fieldIn(container, 'comments');
    if (pickup) shared['Pickup point'] = pickup.value;
    var items = [];
    people(container).forEach(function (block) {
      var properties = {};
      Object.keys(shared).forEach(function (k) {
        properties[k] = shared[k];
      });
      properties['Passenger name'] = fieldIn(block, 'name').value;
      // One contact number per booking, saved on every passenger's line.
      properties['Passenger phone'] = fieldIn(container, 'phone').value;
      var rooming = fieldIn(block, 'rooming');
      if (rooming && rooming.value) properties['Rooming with'] = rooming.value;
      if (comments && comments.value) properties['Comments'] = comments.value;
      items.push({ id: Number(variantId), quantity: 1, properties: properties });
    });
    return items;
  }

  function afterAdd(container, added, variantId) {
    people(container).forEach(function (block) {
      block.querySelectorAll('[data-hj-passenger-field]').forEach(function (field) {
        if (!field.hasAttribute('data-hj-keep')) field.value = '';
      });
    });
    var comments = fieldIn(container, 'comments');
    if (comments) comments.value = '';
    if (container.hjSeats && typeof container.hjSeats[variantId] === 'number') {
      container.hjSeats[variantId] = Math.max(container.hjSeats[variantId] - added, 0);
    }
    var count = container.querySelector('[data-hj-count]');
    if (count) count.value = '1';
    syncPeople(container);
    capCount(container);
    showStatus(container, added > 1 ? fill(container.dataset.msgAddedMany, { count: added }) : container.dataset.msgAdded);
  }

  function addToCart(form, container, items) {
    var productForm = form.closest('product-form');
    var button = form.querySelector('[type="submit"]');
    var spinner = productForm && productForm.querySelector('.loading__spinner');
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var variantId = String(items[0].id);
    var showError = function (message) {
      if (productForm && productForm.handleErrorMessage) productForm.handleErrorMessage(message);
      else showStatus(container, message);
    };

    if (button && button.getAttribute('aria-disabled') === 'true') return;
    showError(false);
    showStatus(container, '');
    if (button) {
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('loading');
    }
    if (spinner) spinner.classList.remove('hidden');

    var body = { items: items };
    if (cart) {
      body.sections = cart.getSectionsToRender().map(function (section) {
        return section.id;
      });
      body.sections_url = window.location.pathname;
      cart.setActiveElement(document.activeElement);
    }

    return fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        var hasPubSub = typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined';
        if (response.status) {
          if (hasPubSub) {
            publish(PUB_SUB_EVENTS.cartError, { source: 'product-form', productVariantId: variantId, errors: response.errors || response.description, message: response.message });
          }
          showError(response.description || response.message || container.dataset.msgError);
          return;
        }
        var added = (response.items || []).length;
        if (!cart) {
          window.location = window.routes.cart_url;
          return;
        }
        if (hasPubSub) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: variantId, cartData: response });
        var first = response.items && response.items[0];
        cart.renderContents(Object.assign({}, response, { id: Number(variantId), key: first && first.key }));
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        if (added < items.length) {
          showError(fill(container.dataset.msgPartial, { added: added, count: items.length }));
          return;
        }
        afterAdd(container, added, variantId);
      })
      .catch(function (error) {
        console.error(error);
        showError(container.dataset.msgError);
      })
      .finally(function () {
        if (button) {
          button.classList.remove('loading');
          button.removeAttribute('aria-disabled');
        }
        if (spinner) spinner.classList.add('hidden');
      });
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      var container = containerFor(form);
      if (!container) return;
      event.preventDefault();
      event.stopImmediatePropagation();

      var shared = [fieldIn(container, 'pickup'), fieldIn(container, 'phone')].filter(Boolean);
      var perPerson = [];
      people(container).forEach(function (block) {
        block.querySelectorAll('[data-hj-passenger-field]').forEach(function (field) {
          perPerson.push(field);
        });
      });
      var comments = fieldIn(container, 'comments');
      var fields = shared.concat(perPerson, comments ? [comments] : []);
      for (var i = 0; i < fields.length; i++) {
        if (!validate(fields[i], container)) {
          showStatus(container, '');
          fields[i].reportValidity();
          return;
        }
      }

      var idInput = form.querySelector('[name="id"]');
      if (!idInput || !idInput.value || idInput.disabled) return;
      var wanted = people(container).length;
      var left = seatsLeft(container);
      if (wanted > left) {
        showStatus(container, fill(container.dataset.msgSeats, { count: left }));
        capCount(container);
        return;
      }
      addToCart(form, container, buildItems(container, idInput.value));
    },
    true
  );

  function onEdit(event) {
    var field = event.target;
    if (field.matches && field.matches('[data-hj-count]')) {
      var container = field.closest('[data-hj-passenger-form]');
      syncPeople(container);
      showStatus(container, '');
      return;
    }
    if (field.matches && field.matches('input.product-variant-id')) {
      // Dawn changes this hidden input when the customer picks another date or stop.
      var form = field.form;
      var tour = form && containerFor(form);
      if (tour) capCount(tour);
      return;
    }
    if (!field.dataset || !field.dataset.hjPassengerField) return;
    field.setCustomValidity('');
    var box = field.closest('[data-hj-passenger-form]');
    if (box) showStatus(box, '');
  }
  document.addEventListener('input', onEdit);
  document.addEventListener('change', onEdit);

  function init() {
    document.querySelectorAll('[data-hj-passenger-form]').forEach(function (container) {
      syncPeople(container);
      capCount(container);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
